import LocalStorageService from './local-storage';
import { User } from '../@types';

export const AUTH_SESSION_CHANGED_EVENT = 'aqila-auth-session-changed';

const dispatchSessionChanged = () => {
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_CHANGED_EVENT));
};

class AuthSession {
  private readonly APP_BASENAME = '/aqila-2';

  private readonly LOGIN_ROUTE = '/login';

  isAuthenticated() {
    const user = LocalStorageService.getItem('user');
    return !!user?.token;
  }

  login({ user }: { user: User }) {
    LocalStorageService.setItem('user', user);

    dispatchSessionChanged();
  }

  logout() {
    const apiHostUrl = LocalStorageService.getItem('apiHostUrl');
    LocalStorageService.clear();

    if (apiHostUrl) {
      LocalStorageService.setItem('apiHostUrl', apiHostUrl);
    }

    dispatchSessionChanged();
  }

  logoutAndRedirectToLogin() {
    this.logout();
    window.location.assign(`${this.APP_BASENAME}${this.LOGIN_ROUTE}`);
  }

  expireSession(redirect?: string) {
    this.logout();

    const isOnLoginPage = window.location.pathname.endsWith(this.LOGIN_ROUTE);

    if (!isOnLoginPage) {
      window.location.href = `${this.APP_BASENAME}${this.buildLoginUrl(
        redirect,
      )}`;
    }
  }

  normalizeRedirect(redirect: string): string {
    if (redirect.startsWith(this.APP_BASENAME)) {
      return redirect.replace(this.APP_BASENAME, '');
    }

    return redirect;
  }

  buildLoginUrl(redirect?: string) {
    if (!redirect) return this.LOGIN_ROUTE;

    return `${this.LOGIN_ROUTE}?redirect=${encodeURIComponent(redirect)}`;
  }

  getLoginUrl(redirect?: string) {
    return this.buildLoginUrl(redirect);
  }
}

export default new AuthSession();
